export default __webpack_public_path__ + "static/media/AngelaMartin.1909e19a.jpg";